import React from "react";
import PropTypes from 'prop-types';

export default class Placeholder extends React.PureComponent {
    componentDidMount() {

    }

    render() {
        let { children, className } = this.props;

        return (
            <div className={`placeholder ${className}`}>{children}</div>
        );
    }
}

Placeholder.propTypes = {
    className: PropTypes.string.isRequired,
    children: PropTypes.node,
};
